<template>
  <div class="relative min-h-screen">
    <!-- Background image -->
    <div
      class="absolute inset-0 pointer-events-none"
      :style="backgroundStyle"
    />

    <!-- Content -->
    <div class="relative z-10">
      <router-view />
    </div>

    <noscript>
      You need to enable JavaScript to use the communication tool powered by
      OpenWidget.
    </noscript>
  </div>
</template>

<script setup>
import { computed, onMounted } from "vue";

const backgroundStyle = computed(() => ({
  backgroundPosition: "left top",
  backgroundRepeat: "no-repeat",
  backgroundSize: "230px",
}));

const initOpenWidget = () => {
  if (window.OpenWidget) {
    try {
      window.OpenWidget.call("show");
    } catch (e) {
      console.log(e);
    }
    return;
  }

  window.__ow = window.__ow || {};
  window.__ow.organizationId = "e500e7a3-3721-4677-897d-6a5c5c613c72";
  window.__ow.integration_name = "manual_settings";
  window.__ow.product_name = "openwidget";

  (function (n, t, c) {
    function i(args) {
      return e._h ? e._h.apply(null, args) : e._q.push(args);
    }

    const e = {
      _q: [],
      _h: null,
      _v: "2.0",

      on() {
        i(["on", c.call(arguments)]);
      },

      once() {
        i(["once", c.call(arguments)]);
      },

      off() {
        i(["off", c.call(arguments)]);
      },

      get() {
        if (!e._h) {
          throw new Error("[OpenWidget] You can't use getters before load.");
        }
        return i(["get", c.call(arguments)]);
      },

      call() {
        i(["call", c.call(arguments)]);
      },

      init() {
        const script = t.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = "https://cdn.openwidget.com/openwidget.js";
        t.head.appendChild(script);
      },
    };

    if (!n.__ow.asyncInit) {
      e.init();
    }

    n.OpenWidget = n.OpenWidget || e;
  })(window, document, [].slice);
};

onMounted(() => {
  initOpenWidget();
});
</script>
